<template>
  <div>
    <a-form-model label-width="110px" class="SiftActivity UniformCss">
      <el-row>
        <el-col :span="4" v-if="false">
          <a-form-model-item label="活动计划编码：">
            <a-input v-model="data.planCode" placeholder="请输入活动计划编码" clearable />
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="名称/编码：">
            <a-input v-model="data.applyNameOrCode" placeholder="输入提报名称/提报编码" clearable />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'writeOff'" :span="4">
          <a-form-model-item label="活动核销编码：">
            <a-input v-model="data.writeoffCode" placeholder="输入活动核销编码" clearable />
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="经理部：">
            <a-input v-model="data.regionName" placeholder="输入经理部" clearable />
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="经销商：">
            <a-input v-model="data.dealerName" placeholder="输入经销商" clearable />
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="预算类型：">
            <a-select v-model="data.budgetTypeCode">
              <a-select-option v-for="item in budgetData" :key="item.valueCode" :value="item.valueCode" >{{item.valueName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="一级来源：">
            <a-select v-model="data.oneLevelCode" filterable clearable @change="oneSourceChange">
              <a-select-option
                v-for="item in oneSourceList"
                :key="item.sourceCode"
                :value="item.sourceCode"
              >{{item.sourceName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="二级来源：">
            <a-select v-model="data.twoLevelCode" filterable clearable @change="twoSourceChange">
              <a-select-option
                v-for="item in twoSourceList"
                :key="item.sourceCode"
                :value="item.sourceCode"
              >{{item.sourceName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="三级来源：">
            <a-select v-model="data.threeLevelCode" filterable clearable>
              <a-select-option v-for="item in threeSourceList" :key="item.sourceCode" :value="item.sourceCode">{{item.sourceName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="计划时间从：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.planStartTimeStart"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-model-item>
        </el-col>
        <el-col :span="4" v-if="false">
          <a-form-model-item label="至：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.planStartTimeEnd"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.planStartTimeStart) - 8.64e7 }"
            />
          </a-form-model-item>
        </el-col>
        <el-col :span="4" v-if="false">
          <a-form-model-item label="计划结束时间从：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.planEndTimeStart"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="至：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.planEndTimeEnd"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.planEndTimeStart) - 8.64e7 }"
            />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'apply'" :span="4">
          <a-form-model-item label="发起时间从：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.applyFlowStartStart"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'apply'" :span="4">
          <a-form-model-item label="至：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.applyFlowStartEnd"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.applyFlowStartStart) - 8.64e7 }"
            />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'writeOff'" :span="4">
          <a-form-model-item label="发起时间从：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.writeoffFlowStartTimeStart"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'writeOff'" :span="4">
          <a-form-model-item label="至：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.writeoffFlowStartTimeEnd"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.writeoffFlowStartTimeStart) - 8.64e7 }"
            />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'writeOff'" :span="4">
          <a-form-model-item label="实际时间从：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.actualStartTimeStart"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'writeOff'" :span="4">
          <a-form-model-item label="至：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.actualStartTimeEnd"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.actualStartTimeStart) - 8.64e7 }"
            />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'apply'" :span="4">
          <a-form-model-item label="提报状态：">
            <a-select v-model="data.applyStatus">
              <a-select-option v-for="(item, i) in SelectLists.ActPlanApplyStatus" :key="i" :value="item.code">{{item.value}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'writeOff'" :span="4">
          <a-form-model-item label="核销状态：">
            <a-select v-model="data.planWriteOffStatus">
              <a-select-option v-for="(item, i) in SelectLists.planWriteOffStatus" :key="i" :value="item.code">{{item.value}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="活动预算从：">
            <a-input v-model="data.totalCostStart" placeholder="输入金额" clearable />
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="至：">
            <a-input v-model="data.totalCostEnd" placeholder="输入金额" clearable />
          </a-form-model-item>
        </el-col>
        <el-col :span="4">
          <a-form-model-item label="品系：">
            <a-select v-model="data.strainsName" clearable style="margin-right: 1rem">
              <a-select-option
                  v-for="item in carStrainsDS"
                  :key="item.strainsCode"
                  :value="item.strains" >{{item.strains}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'writeOff'" :span="4">
          <a-form-model-item label="结算时间从：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.payTimeStart"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-model-item>
        </el-col>
        <el-col v-if="siftType === 'writeOff'" :span="4">
          <a-form-model-item label="至：">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.payTimeEnd"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.writeoffFlowStartTimeStart) - 8.64e7 }"
            />
          </a-form-model-item>
        </el-col>
      </el-row>
    </a-form-model>
  </div>
</template>

<script>
import {queryCarStrainsInfo, queryValueTypeByCode} from '@/api/activity' // 活动类接口
import { findDlrSelectList, getSourceSelectList } from '@/api/base-data'

export default {
  name: 'SiftReimburse',
  props: ['data', 'siftType', 'sectorList'],
  data() {
    return {
      budgetData: [],
      SelectLists: {},
      carStrainsDS: [],
      dealerList: []
    }
  },
  computed: {
    oneSourceList() {
      if (this.siftType === 'apply') {
        return this.$store.state.actApplyListPage.sourceList.oneSourceList
      } else {
        return this.$store.state.actVerListPage.sourceList.oneSourceList
      }
    },
    twoSourceList() {
      if (this.siftType === 'apply') {
        return this.$store.state.actApplyListPage.sourceList.twoSourceList
      } else {
        return this.$store.state.actVerListPage.sourceList.twoSourceList
      }
    },
    threeSourceList() {
      if (this.siftType === 'apply') {
        return this.$store.state.actApplyListPage.sourceList.threeSourceList
      } else {
        return this.$store.state.actVerListPage.sourceList.threeSourceList
      }
    }
  },
  watch: {
  },
  created() {
    this.getBudgettype() // 预算类型
    // 下拉框获取
    this.SelectListsFun()
    // 经销商下拉框获取
    this.getDealerList()
    // 获取活动来源下拉框数据
    this.getFiveSource(1)
    //获取品系
    this.getCarStrains()
  },
  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['ActPlanApplyStatus', 'TypesOfPresentation', 'planWriteOffStatus']).then(v => {
        this.SelectLists = v
      })
    },
    // 获取预算类型
    getBudgettype() {
      queryValueTypeByCode({ typeCode: 'budgetary', page: 1, limit: 999 }).then(res => {
        if (res.code === 1) {
          this.budgetData = res.data.list
        }
      })
    },
    getDealerList() {
      findDlrSelectList({}).then(res => {
        if (res.code === 1) {
          this.dealerList = res.data.list
        }
      })
    },
    // 获取活动来源下拉框数据
    getFiveSource(level, parentId) {
      const data = {
        level: level,
        parentId: null
      }
      if (parentId) {
        data.parentId = parentId
      }
      getSourceSelectList(data).then(res => {
        if (res.code === 1) {
          this.handleSelectList(level, res.data)
        }
      })
    },
    // 将来源分为一级二级三级，对应下拉框
    handleSelectList(level, data) {
      const param = {
        level: level,
        list: data
      }

      if (this.siftType === 'apply') {
        this.$store.commit('actApplyListPage/updateSourceList', param)
      } else {
        this.$store.commit('actVerListPage/updateSourceList', param)
      }
    },
    oneSourceChange(value) {
      if (value) {
        const param = this.oneSourceList.find(item => item.sourceCode === value)
        this.getFiveSource(2, param.sourceId)
      } else {
        // 清空2，3级来源列表
        this.handleSelectList(2, [])
        this.handleSelectList(3, [])
      }
    },
    // 获取品系
    getCarStrains() {
      queryCarStrainsInfo().then(res => {
        if (res.code === 1) {
          this.carStrainsDS = res.data.list
        }
      })
    },
    twoSourceChange(value) {
      if (value) {
        const param = this.twoSourceList.find(item => item.sourceCode === value)
        this.getFiveSource(3, param.sourceId)
      } else {
        // 清空3级来源列表
        this.handleSelectList(3, [])
      }
    }

  }
}
</script>
<style lang="less">
// .SiftActivity {
//   .el-form-item {
//     display: inline-block;
//   }
// }
.el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 0 0 0;
}
.el-col-4 {
  width: 16%;
  margin-right: 0rem;
}
.SiftReimburse {
  .a-form-model-item {
    display: inline-block;
  }
}
</style>
